$(document).ready(function() {
	
	if($('body').attr('data-template') == 'collection' || $('body').attr('data-template') == 'search'){
    // Function to check if all ".boost-sd__product-item" elements are loaded
    function checkElementsLoaded() {
        var allItemsLoaded = $(".boost-sd__product-item").length === $(".boost-sd__product-item:visible").length;
        console.log(allItemsLoaded+ "initail load");
        if (allItemsLoaded) {
            // Your script here
 
			var allitems = $(".boost-sd__product-item").length;
			// Your script here
			console.log(allitems+" items elements are rendered");
			$(".boost-sd__product-swatch-option").each(function() {
				var labelText = $(this).find('.boost-sd__radio-label').text().trim();
				$(this).find('.boost-sd__radio-label').addClass(function(index, currentClass) {
					return labelText;
				});



			});

      $(".boost-sd__btn-quick-view").click(function(){
        setTimeout(function(){ 
          console.log("quick view clicked");
          $(".boost-sd__product-swatch-option").each(function() {
            var labelText = $(this).find('.boost-sd__radio-label').text().trim();
            $(this).find('.boost-sd__radio-label').addClass(function(index, currentClass) {
              return labelText;
            });
    
    
    
          });
        }, 2000); 



    });
      
			
            // Stop the interval once elements are loaded
            clearInterval(intervalId);

			$(window).on("scroll", function() {
				if(allitems != $(".boost-sd__product-item").length){
					console.log("added more items")
					$(".boost-sd__product-swatch-option").each(function() {
						var labelText = $(this).find('.boost-sd__radio-label').text().trim();
						$(this).find('.boost-sd__radio-label').addClass(function(index, currentClass) {
							return labelText;
						});
					});
				}
			
			  } );
        } else {
            console.log("Not all .boost-sd__product-item elements are loaded yet.");
        }
    }

    // Check every 500 milliseconds (adjust as needed)
    var intervalId = setInterval(checkElementsLoaded, 2000);

    setTimeout(checkElementsLoaded, 4000);
	}

});